import React, { useState, useEffect, useContext } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import "./css/TableReg.css";
import "./css/tableAreaReg.css";
import 'bootstrap/dist/css/bootstrap.css';
import tick from './images/icons/check.png'
import cross from './images/icons/cross.png'
import edit from './images/MenuReg/Editing1.png'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import Select from 'react-select';
import { DBContext } from './DBContext'
import SideNavMob from './SideNavMob'
import NavBarMobile from './Mobile/NavBar'
import axios from 'axios'

function TableAreaReg() {

    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { logginedDB , sideNavState , sideNavStateFunc } = useContext(DBContext);

    const location = useLocation(null)

    const [areaInfo,setAreaInfo] = useState({})
    // //(areaInfo);
    

    const [areaId,setAreaId] = useState(null)
    const [area,setArea] = useState(null)

    useEffect(() => {
        if (location.state) {
            setAreaId(location.state.id)
            setArea(location.state.area)
        }
    },[location])

    const [options,setOptions] = useState([])

    const handleModifyArea = async () => { 
        try {
            const response = await axios.get(`${api_base_url}/getAreaDetails/${areaId}/${logginedDB}`)
            if (response.status == 200) {
                const transformedAreaInfo = {
                    areaName: response.data[0].AreaName,
                    areaCode: response.data[0].AreaCode,
                    captain: response.data[0].Captain,
                    // containerCharge: response.data[0].ContainerCharge,
                    tables: response.data[0].AreaTables
                };
                // //(transformedAreaInfo);
                
                setAreaInfo(transformedAreaInfo);

                const selectedOption = options.find(option => option.value === response.data[0].Captain);
                
                setSelectedCaptain(selectedOption);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        handleGetCaptains()
        if (areaId && options.length > 0) {
            handleModifyArea()
        }
    },[areaId,logginedDB,options])

    window.addEventListener('load', function() {
        var contentContainer = document.getElementById('contentContainer');
        // Check if content exceeds container height
        if (contentContainer.scrollHeight <= contentContainer.clientHeight) {
          contentContainer.classList.add('hide-scrollbar');
        } else {
          contentContainer.classList.remove('hide-scrollbar');
        }
      });

      const customStyles = {
        option: (provided, state) => ({
            ...provided,
            width: '100%',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF', 
            backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
              }
        }),
        input: (provided) => ({
            ...provided,
            // height: '2.5rem',
            width: '100% !important',
            cursor: 'none',
            '&:hover': {
                cursor: 'text'
            },
            '&:focus': {
                cursor: 'default',
            },
            // display: 'none', 
          }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'hidden', 
          }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            // display: 'none', 
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: '2.5rem', // Adjust height of dropdown indicator to match control height
            marginTop: 0, // Adjust vertical alignment if needed
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100% !important',
            height: '2.5rem',
            fontSize: '1em',
            height: '2.5rem',
            border: '1px solid #C6C6C6',
            borderRadius: '0.313rem',
            textAlign: 'left',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #C6C6C6', 
            },
            '&:focus': {
            outline: 'none', // Remove outline on focus
            cursor: 'default', // Remove cursor on focus
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '1rem',
            // lineHeight: '2.5rem',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: '.9rem',
            textAlign: 'left',
            // height: '2.5rem',
        }),
    };;

    const [codeDisable,setCodeDisable] = useState(true)

    function getInitialsUppercase(str) {
        if (!str) return ""; // Handle empty or null strings
        return str
            .split(' ')               // Split the string into words
            .map(word => word[0]?.toUpperCase() || '') // Get the first letter of each word in uppercase
            .join('');                // Join the initials into a single string
    }

    const [avail,setAvail] = useState(null)
    const [availCode,setAvailCode] = useState(null)
    const [autoAreaCode,setAutoAreaCode] = useState(null)

    const handleAutoAreaCode = async (val) => {
        const code = getInitialsUppercase(val)
        try {
            const response = await axios.get(`${api_base_url}/autoAreaCode/${code}/${logginedDB}`)
            if (response.status === 200) {
                const codeAvail = response.data.nextAvailableCode
                setAutoAreaCode(codeAvail)
                setAreaInfo((prev) => ({
                    ...prev,
                    'areaCode' : codeAvail
                }))
            }
        } catch (error) {
            //(error);
        }
    }

    const handleCheckAvailableName = async (val) => {
        if (val === '') return setAvail(null)
        try {
            const response = await axios.get(`${api_base_url}/checkAvailablity/${val}/${logginedDB}`)
            if (response.status === 200) {
                const checked = response.data.isAvailable
                if (checked == 0) {
                    setAvail(1)
                    handleAutoAreaCode(val)
                } else {
                    setAvail(0)
                    setAutoAreaCode(null)
                }
            }
        } catch (error) {
            //(error);
        }
    }

    const handleCheckAvailableCode = async (val) => {
        if (val === '') return setAvailCode(null)
        try {
            const response = await axios.get(`${api_base_url}/checkAvailablityCode/${val}/${logginedDB}`)
            if (response.status === 200) {
                const checked = response.data.isAvailable
                
                if (checked == 0) {
                    setAvailCode(1)
                } else {
                    setAvailCode(0)
                }
            }
        } catch (error) {
            //(error);
        }
    }

    const [selectedCaptain,setSelectedCaptain] = useState()

    // //(areaInfo);
    
      const handleOnChangeArea = async (e,fieldName) => {
        if (fieldName === 'areaName') {
            const value = e.target.value
            setCodeDisable(true)
            handleCheckAvailableName(value)
            setAreaInfo((prev) => ({
                ...prev,
                [fieldName] : value
            }))
        } else if (fieldName === 'captain') {
            setSelectedCaptain(e)
            setAreaInfo((prev) => ({
                ...prev,
                [fieldName] : e.value
            }))
        } else if (fieldName === 'areaCode') {
            if (!codeDisable) {
                const value = e.target.value
                handleCheckAvailableCode(value)
                setAreaInfo((prev) => ({
                    ...prev,
                    [fieldName] : value
                }))
            }
        } else if (fieldName === 'tables') {
            const value = e.target.value.replace(/\D/g, '');
            setAreaInfo((prev) => ({
                ...prev,
                [fieldName] : value
            }))
        } else {
            const value = e.target.value
            setAreaInfo((prev) => ({
                ...prev,
                [fieldName] : value
            }))
        }
      }

      const navigate = useNavigate();

      const handleCancel = () => {
        navigate('/basemenureg',{
            state : 'areaCancel'
        })
      }
    
      const secret = 'secret'

      const handleSaveArea = async () => {

        if ((avail == 0 || avail == null) || !codeDisable && (availCode == null || availCode == 0)) {
            return alert("Incorrect")
        }

        const hasNoCaptain = !areaInfo.captain || areaInfo.captain === 0;
        if (hasNoCaptain) {
            const confirmRegister = window.confirm("Captain not registered. Are you sure to register this area?");
            if (!confirmRegister) {
                return;
            }
        }

        try {
            const currentDate = new Date().toISOString().split('T')[0];

            const requestBody = {
                ...areaInfo,
                captain: areaInfo.captain || null,
                currentDate: currentDate,
                secret: secret
            };

            const response = await fetch(`${api_base_url}/postAreaInfo/${logginedDB}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody),
            });
            
            if (response.status == 200) {
                alert("data saved")
                handleCancel()
            }
    
            const data = await response.json();
    
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }

    const handleUpdateArea = async () => {

        const hasNoCaptain = !areaInfo.captain || areaInfo.captain === 0;
        if (hasNoCaptain) {
            const confirmRegister = window.confirm("Captain not registered. Are you sure to register this area?");
            if (!confirmRegister) {
                return;
            }
        }

        try {
            const currentDate = new Date().toISOString().split('T')[0];

            const requestBody = {
                ...areaInfo, 
                captain: areaInfo.captain || null,
                id: areaId,
                modifiedDate: currentDate,
                secret: secret
            };

            const response = await fetch(`${api_base_url}/updateAreaInfo/${logginedDB}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody),
            });
            
            if (response.status == 200) {
                alert("data saved")
                handleCancel()
            }
    
            const data = await response.json();
    
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }

    const [sideNav,setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }

    const [falseState,setFalseState] = useState(null)

    
    

    const handleGetCaptains = async () => {
        // //("hiii",logginedDB);
         
        try {
            const response = await axios.get(`${api_base_url}/getCaptains/${logginedDB}`)
            if (response.status === 200) {
                const transformedData = response.data.map(item => ({
                    value: item.id_user,
                    label: item.userFullName
                }));
                setOptions(transformedData);
            }
        } catch (error) {
            //(error);
        }
    }

    const handleModifyAreaCode = async () => {

        const userConfirmed = window.confirm(`Custom area code ?`);

        if (!userConfirmed) {
            return;
        }
        handleCheckAvailableCode(availCode)
        setCodeDisable(false)
    }
    

    return (
        <div className='w-screen h-screen flex flex-col overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <SherDineNav  sideNav={(state) => handleSideNav(state)} falseState={falseState}/>
                <div className='TableRegContentDiv flex gap-3'>
                    <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)}/>
                    <div className='TableRegContentSideBarRight TableRegContentSideBarRight_TableAreaReg'>
                        <div className="RegSidebar">
                            <TopRootDiv  image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Area'}/>
                        </div>
                        <div className='Container_Menu Container_Menu_TableAreaReg pt-3 flex flex-col h-full'>
                            <div className='TableAreaReg_areaDetails_span bg-white rounded-t-md border-b'>
                                <span>{area ? area : 'Area Details'}</span>
                                <div className=' AddItem_Buttons AddItem_Buttons_TableAreaReg'>
                                    <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                    <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={areaId ? handleUpdateArea : handleSaveArea}>Save</button>
                                </div>
                            </div>
                            <div className='p-4 flex flex-col bg-white gap-4 flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200' id="contentContainer">
                                <div className='TableAreaReg_areaDetails_Reg_input_div mb-0'>
                                    <div className='Reg_input_div'>
                                        <div className='flex w-full'>
                                            <span className='w-1/2 text-left'>Area Name</span>
                                            {/* { avail == 1 && <span className='w-1/2 text-right'>available</span> }
                                            { avail == 0 && <span className='w-1/2 text-right'>exists</span> } */}
                                        </div>
                                        <div className='w-full flex areaBorder rounded-[.313rem]'>
                                            <input className='w-full border-0' type="text" 
                                            value={areaInfo.areaName}
                                            onChange={(e) => handleOnChangeArea(e,'areaName')}/>
                                            <div className='w-max flex justify-center items-center p-2'>
                                                { avail == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                                { avail == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='Reg_input_div'>
                                        <span>Area Code</span>
                                        <input type="text" 
                                        // value={areaInfo.areaCode}
                                        value={areaInfo.areaName !== '' ? autoAreaCode : ''}
                                        disabled
                                        onChange={(e) => handleOnChangeArea(e,'areaCode')}/>
                                    </div> */}
                                    <div className='Reg_input_div'>
                                        <span>Area Code</span>
                                        <div className={`w-full flex areaBorder rounded-[.313rem] ${codeDisable ? 'bg-slate-100' : ''}`}>
                                            <input className='w-full border-0' type="text" 
                                            value={(areaInfo.areaName !== '' && avail == 1 && codeDisable) ? autoAreaCode : !codeDisable ? areaInfo.areaCode : areaId ? areaInfo.areaCode : ''}
                                            disabled={codeDisable}
                                            onChange={(e) => handleOnChangeArea(e,'areaCode')}/>
                                            {
                                                (areaInfo.areaName !== '' && autoAreaCode && avail == 1 && codeDisable) && (
                                                    <div className='w-max flex justify-center items-center p-2'>
                                                        <img className='w-[1.25rem] cursor-pointer' src={edit} alt="" onClick={handleModifyAreaCode}/>
                                                    </div>
                                                )
                                            }
                                            {
                                                !codeDisable && (
                                                    <div className='w-max flex justify-center items-center p-2'>
                                                        { availCode == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                                        { availCode == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='TableAreaReg_areaDetails_Reg_input_div mb-0'>
                                    <div className='Reg_input_div'>
                                        <span className='text-[1rem] w-full font-[500] font-nunito'>Captain Name</span>
                                        <Select
                                            styles={customStyles}
                                            value={selectedCaptain}
                                            onChange={(e) => handleOnChangeArea(e,'captain')}
                                            options={options}
                                            // isDisabled={userDetails && disabled}
                                            />
                                    </div>
                                    {/* <div className='flex flex-col w-1/2 gap-[.25rem]'>
                                        <span>Container Charge</span>
                                        <input className='h-[2.5rem] rounded-[.313rem] pl-[.5rem] pr-[.5rem]' type="number" 
                                        value={areaInfo.containerCharge}
                                        onChange={(e) => handleOnChangeArea(e,'containerCharge')}/>
                                    </div> */}
                                    {/* </div> */}
                                    {/* <div className='TableAreaReg_areaDetails_Reg_input_div mb-0'> */}
                                    <div className='Reg_input_div'>
                                        <span>No of Tables</span>
                                        <input type="text" 
                                        style={{textAlign:'right'}}
                                        value={areaInfo.tables}
                                        onChange={(e) => handleOnChangeArea(e,'tables')}/>
                                    </div>
                                    {/* <div className='Reg_input_div'>
                                    </div> */}
                                </div>
                            </div>
                        
                        </div>
                        
                    </div>
                </div>
            </div>

            {/*  ...............................mobileView..................................... */}
            
            <div className='w-full h-full flex flex-col sm:!hidden overflow-hidden'>
                <div className='w-full h-max sticky top-0'>
                    <NavBarMobile title={'Add Area'}/>
                </div>
                <div className='relative w-full h-full flex bg-[#f5f5f5] overflow-hidden' onClick={(e) =>sideNavStateFunc(true)}>
                    <div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${
                        sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
                    }`}>
                        <SideNavMob focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)}/>
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 p-3'>
                        <div className='h-full p-3 flex flex-col bg-[#fff] gap-2 rounded-[.313rem] overflow-auto noScroll' id="contentContainer">
                            <div className='w-full flex flex-col gap-1 mb-0'>
                                <div className='w-full flex flex-col gap-1'>
                                    <div className='flex w-full'>
                                        <span className='w-1/2 text-left'>Area Name</span>
                                        {/* { avail == 1 && <span className='w-1/2 text-right'>available</span> }
                                        { avail == 0 && <span className='w-1/2 text-right'>exists</span> } */}
                                    </div>
                                    <div className='w-full flex areaBorder rounded-[.313rem]'>
                                        <input className='w-full border-0 p-2' type="text" 
                                        value={areaInfo.areaName}
                                        onChange={(e) => handleOnChangeArea(e,'areaName')}/>
                                        <div className='w-max flex justify-center items-center p-2'>
                                            { avail == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                            { avail == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='Reg_input_div'>
                                    <span>Area Code</span>
                                    <input type="text" 
                                    // value={areaInfo.areaCode}
                                    value={areaInfo.areaName !== '' ? autoAreaCode : ''}
                                    disabled
                                    onChange={(e) => handleOnChangeArea(e,'areaCode')}/>
                                </div> */}
                                <div className='w-full flex flex-col gap-1'>
                                    <span>Area Code</span>
                                    <div className={`w-full flex areaBorder rounded-[.313rem] ${codeDisable ? 'bg-slate-100' : ''}`}>
                                        <input className='w-full border-0 p-2' type="text" 
                                        value={(areaInfo.areaName !== '' && avail == 1 && codeDisable) ? autoAreaCode : !codeDisable ? areaInfo.areaCode : areaId ? areaInfo.areaCode : ''}
                                        disabled={codeDisable}
                                        onChange={(e) => handleOnChangeArea(e,'areaCode')}/>
                                        {
                                            (areaInfo.areaName !== '' && autoAreaCode && avail == 1 && codeDisable) && (
                                                <div className='w-max flex justify-center items-center p-2'>
                                                    <img className='w-[1.25rem] cursor-pointer' src={edit} alt="" onClick={handleModifyAreaCode}/>
                                                </div>
                                            )
                                        }
                                        {
                                            !codeDisable && (
                                                <div className='w-max flex justify-center items-center p-2'>
                                                    { availCode == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                                    { availCode == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex flex-col gap-[1rem]'>
                                <div className='flex flex-col w-full gap-[.25rem]'>
                                    <span className='text-[1rem] font-[500] font-nunito'>Captain Name</span>
                                    <Select
                                        styles={customStyles}
                                        value={selectedCaptain}
                                        onChange={(e) => handleOnChangeArea(e,'captain')}
                                        options={options}
                                        // isDisabled={userDetails && disabled}
                                        />
                                </div>
                                {/* <div className='flex flex-col w-full gap-[.25rem]'>
                                    <span>Container Charge</span>
                                    <input className='h-[2.5rem] rounded-[.313rem] p-2' type="number" 
                                    value={areaInfo.containerCharge}
                                    onChange={(e) => handleOnChangeArea(e,'containerCharge')}/>
                                </div>
                            </div> */}
                            {/* <div className='w-full flex flex-col gap-1 mb-0'> */}
                                <div className='flex flex-col w-full gap-[.25rem]'>
                                    <span>No of Tables</span>
                                    <input type="text" className='p-2'
                                    style={{textAlign:'right'}}
                                    value={areaInfo.tables}
                                    onChange={(e) => handleOnChangeArea(e,'tables')}/>
                                </div>
                            </div>
                        </div>
                        <div className='flex w-full h-max gap-3'>
                            <button className='w-1/2 loginBorder text-[#0008B4] rounded-[.313rem] py-2' onClick={handleCancel}>Cancel</button>
                            <button className='w-1/2 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] py-2' onClick={areaId ? handleUpdateArea : handleSaveArea}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TableAreaReg
